module.exports = __webpack_public_path__ + "img/llo.fec773ad.jpg";